<template>
  <div>
    <base-block rounded title="Test Details">
      <div class="bg-white rounded p-3 pr-3 pl-3 mb-3">
        <div class="d-flex pro-det p-2">
          <p class="mb-0 w-25">Question Selection Type</p>
          <p class="mb-0 w-25 text-right">:</p>
          <p class="mb-0 text-center w-50">
            <b>{{
              test.test_type == "random"
                ? "Random"
                : test.test_type == "default"
                ? "Default"
                : "-"
            }}</b>
          </p>
        </div>
        <div class="d-flex pro-det p-2">
          <p class="mb-0 w-25">Duration</p>
          <p class="mb-0 w-25 text-right">:</p>
          <p class="mb-0 text-center w-50">
            <b>{{ test.duration ? test.duration : "-" }}</b>
          </p>
        </div>
        <div class="d-flex pro-det p-2">
          <p class="mb-0 w-25">Total Question Count</p>
          <p class="mb-0 w-25 text-right">:</p>
          <p class="mb-0 text-center w-50">
            <b>{{ test.no_of_questions ? test.no_of_questions : "-" }}</b>
          </p>
        </div>
        <div class="d-flex pro-det p-2">
          <p class="mb-0 w-25">Attempts</p>
          <p class="mb-0 w-25 text-right">:</p>
          <p class="mb-0 text-center w-50">
            <b>{{ test.attempts ? test.attempts : "-" }}</b>
          </p>
        </div>
        <div class="d-flex pro-det p-2">
          <p class="mb-0 w-25">Negative Marks</p>
          <p class="mb-0 w-25 text-right">:</p>
          <p class="mb-0 text-center w-50">
            <b>{{ test.negative_mark ? test.negative_mark : "-" }}</b>
          </p>
        </div>
        <div class="d-flex pro-det p-2">
          <p class="mb-0 w-25">Each Question Mark</p>
          <p class="mb-0 w-25 text-right">:</p>
          <p class="mb-0 text-center w-50">
            <b>{{ test.each_question_mark ? test.each_question_mark : "-" }}</b>
          </p>
        </div>
        <div class="d-flex pro-det p-2">
          <p class="mb-0 w-25">Start Date & Time</p>
          <p class="mb-0 w-25 text-right">:</p>
          <p class="mb-0 text-center w-50">
            <b>{{ test.start_date_time ? test.start_date_time : "-" }}</b>
          </p>
        </div>
        <div class="d-flex pro-det p-2">
          <p class="mb-0 w-25">End Date & Time</p>
          <p class="mb-0 w-25 text-right">:</p>
          <p class="mb-0 text-center w-50">
            <b>{{ test.end_date_time ? test.end_date_time : "-" }}</b>
          </p>
        </div>
        <div class="d-flex pro-det p-2">
          <p class="mb-0 w-25">Coding</p>
          <p class="mb-0 w-25 text-right">:</p>
          <p class="mb-0 text-center w-50">
            <b>{{ test.has_coding == 1 ? "Yes" : "No" }}</b>
          </p>
        </div>
        <div class="d-flex pro-det p-2">
          <p class="mb-0 w-25">Result Status</p>
          <p class="mb-0 w-25 text-right">:</p>
          <p class="mb-0 text-center w-50">
            <b>{{
              test.result_status == 1
                ? "Result"
                : test.result_status == 2
                ? "Result & Solution"
                : test.result_status == 3
                ? "No Result"
                : "-"
            }}</b>
          </p>
        </div>
      </div>

      <br />
    </base-block>

    <base-block rounded title="Test Question Details">
      <b-table-simple responsive bordered striped table-class="table-vcenter">
        <b-thead>
          <b-tr>
            <b-th class="text-center">S.NO</b-th>
            <b-th class="text-center">Parent Topic</b-th>
            <b-th class="text-center">Question Count</b-th>
            <b-th class="text-center">Duration</b-th>
            <b-th class="text-center">Status</b-th>
            <b-th class="text-center" v-if="test.test_type == 'default'"
              >Action</b-th
            >
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(question, index) in test_questions" :key="index">
            <b-td class="text-center">
              {{ index + 1 }}
            </b-td>
            <b-td class="text-center">{{ question.topic.name }}</b-td>
            <b-td class="text-center">{{
              question.no_of_questions ? question.no_of_questions : "-"
            }}</b-td>
            <b-td class="text-center">{{
              question.duration ? question.duration : "-"
            }}</b-td>
            <b-td class="text-center">
              <!-- LIVE START -->
              <!-- <b-button
                :class="{ 'btn-danger': !question.topic.status }"
                size="sm"
                :variant="buttonVariant"
                @click="
                  toggleStatus(
                    question.college_status.id,
                    index,
                    question.topic.status
                  )
                "
              >
                {{ question.topic.status ? "Active" : "Deactive" }}
              </b-button> -->
              <!-- LIVE END -->
              <!-- TEST START -->
              <b-button
                :class="{ 'btn-danger': !question.college_status.status }"
                size="sm"
                :variant="buttonVariant"
                @click="
                  toggleStatus(
                    question.college_status.id,
                    index,
                    question.college_status.status
                  )
                "
              >
                {{ question.college_status.status ? "Active" : "Deactive" }}
              </b-button>
              <!-- TEST END -->
            </b-td>
            <b-td class="text-center" v-if="test.test_type == 'default'">
              <b-button
                size="sm"
                variant="alt-primary"
                v-b-modal.modal-1
                @click="getQuestions(question.id)"
              >
                <i class="fa fa-fw fa-eye"></i>
              </b-button>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <!-- modal -->

      <b-modal
        id="modal-1"
        title="Questions"
        size="xl"
        ref="modalone"
        no-close-on-esc
        no-close-on-backdrop
        hide-footer
        @close="questionData = []"
      >
        <!-- legends -->
        <div class="col-md-12" v-if="questionData != ''">
          <dl class="float-right">
            <dt class="green"></dt>
            <dd>Fillups</dd>

            <dt class="blue"></dt>
            <dd>Group</dd>

            <dt class="grey"></dt>
            <dd>MCQ</dd>
          </dl>
          <br />
        </div>
        <!-- Questions list -->

        <div>
          <br />
          <b-list-group
            class="list-group"
            v-for="(question, index) in questionData"
            :key="index"
          >
            <div
              v-for="(quest, index1) in questionData[index].questions"
              :key="index1"
            >
              <b-list-group-item
                :class="
                  questionData[index].questions[index1].question_type ==
                  'fill_in_blank'
                    ? 'border-warning mb-1'
                    : questionData[index].questions[index1].group_question !=
                      null
                    ? 'border-primary mb-1'
                    : 'border-dark mb-1'
                "
                v-html="`${questionData[index].questions[index1].question}`"
              >
              </b-list-group-item>
            </div>
          </b-list-group>
        </div>
        <div class="text-right mt-3" v-if="questionData.length > 0">
          <b-button variant="success" @click="Ok()">Ok</b-button>
        </div>
      </b-modal>
    </base-block>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      test: {},
      test_type: "",
      questions: {},
      questionData: [],
      test_questions: [],
      test_detail: {},
      buttonVariant: "success",
    };
  },

  mounted: async function() {
    this.getTests();
    this.getTestTopics();
  },

  methods: {
    Ok() {
      this.$refs.modalone.hide();
      this.questionData = [];
    },
    async getTestTopics() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/college_sub/mock-test-topics/${this.$route.params.id}/${this.$route.params.col_sub_id} `,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.collegeToken}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.test_questions = response.data.mock_test_topics;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getTests() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/mock-test/detail/${this.$route.params.id} `,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.collegeToken}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.test = response.data.test_detail;
            this.test_type = response.data.test_detail.test_type;
            this.questions = response.data.topic_detail;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async toggleStatus(id, index, status) {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/college_sub/mapped-topic-status/${id}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.collegeToken}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.getTestTopics();
            this.test_questions[index].topic.status = status == 1 ? 0 : 1;
            this.$swal({
              text: `${response.data.message}`,
              icon: status ? "error" : "success",
            });
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getQuestions(id) {
      await axios
        .get(`${this.$store.getters.baseUrl}/mock-tests/questions/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.collegeToken}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.questionData = response.data.topic_questions;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
      if ("MathJax" in window) {
        this.$nextTick(async function() {
          await window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () =>
            console.log("done")
          );
        });
      }
    },
  },
};
</script>

<style scoped>
dl dt {
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: middle;
}
dl dd {
  display: inline-block;
  margin: 0px 10px;
  padding-bottom: 0;
  vertical-align: middle;
}
dl dt.green {
  background: #e5ae67;
}
dl dt.grey {
  background: #343a40;
}
dl dt.blue {
  background: #5179d6;
}
</style>
